import { Card, Flex, Image, Space, Tabs, type TabsProps, theme, Typography } from 'antd'
import { Statistics } from '@pages/referral-program-page/ui/statistics'
import { Management } from '@pages/referral-program-page/ui/management'
import { Conditions } from '@pages/referral-program-page/ui/conditions'
import RefferalImg from '@shared/assets/referral.png'
import useMobileView from '@shared/hooks/isMobile'
import './styled.css'
import { colors } from '@app/providers/config-provider/lib/theme'

const { Title } = Typography

export const ReferralProgram = () => {
    const isMobile = useMobileView()

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Моя статистика',
            children: <Statistics />
        },
        {
            key: '2',
            label: 'Управление средствами',
            children: <Management />
        },
        {
            key: '3',
            label: 'Условия программы',
            children: <Conditions />
        }
    ]
    return (
        <Card style={{ width: 'auto', borderRadius: 0 }}>
            {isMobile ? (
                <Card className={'card'} style={{ width: 'auto' }}>
                    <Title style={{ margin: 0, textAlign: 'center', color: colors.lightTextColor }} level={4}>
                        Приглашайте друзей и получайте вознаграждение до 50% от их подписки!
                    </Title>
                    <Flex justify={'center'}>
                        <Image preview={false} src={RefferalImg} width={149} height={110} className={'referral-img'} />
                    </Flex>
                </Card>
            ) : (
                <>
                    <Card className={'card'}>
                        <Space>
                            <Title style={{ margin: 0, color: colors.lightTextColor }} level={4}>
                                Приглашайте друзей и получайте вознаграждение до 50% от их подписки!
                            </Title>
                            <Image
                                preview={false}
                                src={RefferalImg}
                                width={149}
                                height={110}
                                className={'referral-img'}
                            />
                        </Space>
                    </Card>
                </>
            )}
            {isMobile ? (
                <Tabs className={'mobile-referral'} defaultActiveKey="2" items={items} onChange={() => {}} />
            ) : (
                <Tabs defaultActiveKey="2" items={items} onChange={() => {}} />
            )}
        </Card>
    )
}
